import MetaBillingsCargoTaxiStatusCountersRequest, {
  MetaBillingsCargoTaxiStatusCountersQueryParams,
} from "./meta-billings-cargo-taxi-status-counters.request";

const create = (
  request: MetaBillingsCargoTaxiStatusCountersRequest,
): MetaBillingsCargoTaxiStatusCountersQueryParams => {
  return {
    cargoCompanyId: request.cargoCompanyId,
    taxiCorporationId: request.taxiCorporationId,
  };
};

const metaBillingsCargoTaxiStatusCountersRequestFactory = {
  create,
};

export default metaBillingsCargoTaxiStatusCountersRequestFactory;
